"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.util = exports.is = exports.DefinitionType = exports.FeatureDefinitions = exports.BasicFeatureValue = exports.BrowserProvider = exports.resolveForBrowser = exports.Ensign = void 0;
const flatten_namespace_1 = __importDefault(require("./flatten-namespace"));
const namespace_overrides_1 = __importDefault(require("./namespace-overrides"));
const is_1 = require("./is");
var ensign_1 = require("./ensign");
Object.defineProperty(exports, "Ensign", { enumerable: true, get: function () { return ensign_1.Ensign; } });
var resolve_for_browser_1 = require("./resolve-for-browser");
Object.defineProperty(exports, "resolveForBrowser", { enumerable: true, get: function () { return resolve_for_browser_1.resolveForBrowser; } });
var providers_1 = require("./providers");
Object.defineProperty(exports, "BrowserProvider", { enumerable: true, get: function () { return providers_1.BrowserProvider; } });
var types_1 = require("./types");
Object.defineProperty(exports, "BasicFeatureValue", { enumerable: true, get: function () { return types_1.BasicFeatureValue; } });
Object.defineProperty(exports, "FeatureDefinitions", { enumerable: true, get: function () { return types_1.FeatureDefinitions; } });
Object.defineProperty(exports, "DefinitionType", { enumerable: true, get: function () { return types_1.DefinitionType; } });
exports.is = {
    entity: is_1.entity,
    context: is_1.context,
    featureDefinitions: is_1.featureDefinitions,
};
exports.util = {
    flattenNamespace: flatten_namespace_1.default,
    namespaceOverrides: namespace_overrides_1.default,
};
//# sourceMappingURL=index.js.map